"use client";
import dynamic from "next/dynamic";
import LoadingPage from "./LoadingPage";
import BarTop from "./BarTop";
// const BarTop = dynamic(() => import("./BarTop"), { ssr: false });
// import HomeHeader from "./HomeHeader";
import { MenuProviderQuickCryptoForm } from "../context/MenuContextQuickCryptoForm";
import CustomWindow from "./CustomWindow";
// import CryptoForm from "./CryptoForm";
const CryptoForm = dynamic(() => import("./CryptoForm"), { ssr: false });

// import ScrollTopButton from "./ScrollTopButton";
const ScrollTopButton = dynamic(() => import("./ScrollTopButton"), {
  ssr: false,
});

// import PopupCoupons from "./PopupCoupons";
const PopupCoupons = dynamic(() => import("./PopupCoupons"), { ssr: false });
// import PopupMessages from "./PopupMessages";
const PopupMessages = dynamic(() => import("./PopupMessages"), { ssr: false });
// import GameModal from "./GameModal";
const GameModal = dynamic(() => import("./GameModal"), { ssr: false });
// import FreeSpinModal from "./FreeSpinModal";
const FreeSpinModal = dynamic(() => import("./FreeSpinModal"), { ssr: false });
import { useContext } from "react";
import { AppContext } from "@/src/context/AppContext";
import { GameContext } from "@/src/context/GameContext";

export default function MainComponent({ children }) {
  const {
    pageLoader,
    link,
    openModal,
    setOpenModal,
    setLink,
    isCouponOpen,
    setIsCouponOpen,
    activeCoupon,
    user,
  } = useContext(AppContext);
  const { setSelectedGame } = useContext(GameContext);

  const closeModal = () => {
    setOpenModal(false);
    setLink(null);
    Tawk_API.showWidget();
  };

  const closeCouponModal = () => {
    Tawk_API.showWidget();
    setIsCouponOpen(false);
  };
  return (
    <main id="root">
      <MenuProviderQuickCryptoForm>
        <CustomWindow
          iframeUrl={link}
          isIframeVisible={openModal}
          setIsIframeVisible={closeModal}
          setSelectedGame={setSelectedGame}
        />
        <LoadingPage loader={pageLoader} />
        {/* <HomeHeader /> */}

        {children}

        {user && <CryptoForm />}
        <ScrollTopButton />
        <PopupCoupons
          isOpen={isCouponOpen}
          activeCoupon={activeCoupon}
          onClose={closeCouponModal}
        />
        <PopupMessages />
        <GameModal />
        <FreeSpinModal />
      </MenuProviderQuickCryptoForm>
    </main>
  );
}
